<template>

  <div class="login-page">
    <!-- 背景装饰 -->
    <div class="background-decoration">
      <div class="gradient-bg"></div>
      <div class="floating-particles">
        <div class="particle" v-for="i in 20" :key="i"></div>
      </div>
      <div class="geometric-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
      </div>
    </div>

    <!-- 登录卡片 -->
    <div class="login-container">
      <div class="login-card">
        <!-- 卡片头部 -->
        <div class="card-header">
          <h1 class="welcome-title">欢迎登录</h1>
          <p class="welcome-subtitle">DZ POKER 管理后台</p>
        </div>

        <!-- 登录表单 -->
        <div class="login-form">
          <HpsfirProForm
            :items="loginFormItems"
            hide-cancel
            hide-ok
            hide-colon
            :on-ok="handleLogin"
            ref="formRef"
            class="form-container"
          />

          <div class="form-actions">
            <el-button
              type="primary"
              class="login-button"
              @click="formRef?.submit()"
              :loading="loading"
            >
              <el-icon class="button-icon"><User /></el-icon>
              登录
            </el-button>
          </div>
        </div>

        <!-- 底部信息 -->
        <div class="card-footer">
          <p class="footer-text">安全登录 · 数据保护</p>
          <div class="login-version">
            <span class="version-main">v1.0.0</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧装饰 -->
    <div class="side-decoration">
      <div class="tech-circles">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
        <div class="circle circle-3"></div>
      </div>
      <div class="tech-lines">
        <div class="line line-1"></div>
        <div class="line line-2"></div>
        <div class="line line-3"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { HpsfirProForm, HpsfirProFormItem, HpsfirBrand, useBaseUserStore, useRoute, useRouter } from 'hpsfir-managebase-ui';
import { ref } from 'vue';
import { onKeyStroke } from '@vueuse/core';
import { User } from '@element-plus/icons-vue';

const baseUserStore = useBaseUserStore();
const router = useRouter();
const route = useRoute();
const loading = ref(false);

// 版本信息
const packageVersion = process.env.VUE_APP_PACKAGE_VERSION;
const appVersion = process.env.VUE_APP_VERSION === 'test' ? '测试版' : '正式版';

const formRef = ref<InstanceType<typeof HpsfirProForm>>();
const loginFormItems: HpsfirProFormItem[] = [
  {
    name: 'userNameOrPhone',
    type: 'string',
    label: '账号',
    placeholder: '请输入用户名或手机号',
    rule: [{ required: true, message: '请输入账号' }],
  },
  {
    name: 'password',
    type: 'password',
    label: '密码',
    placeholder: '请输入密码',
    rule: [{ required: true, message: '请输入密码' }],
  },
];

const handleLogin = async(data: any) => {
  loading.value = true;
  try {
    await baseUserStore.login(data.userNameOrPhone, data.password);
    if (route.query.back) {
      await router.replace(route.query.back as string);
      return;
    }
    await router.replace('/');
  } finally {
    loading.value = false;
  }
};

onKeyStroke('Enter', () => {
  formRef.value?.submit();
});
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
